import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const AboutSection = styled.section`
    padding-top: 60px;
`;

export const ShippingSection = styled.section`
    padding-top: 60px;
`;

export const ShippingSubtitle = styled.div`
    margin-top: 15px;

    font-weight: 400;
    font-size: 20px;
    text-align: center;
    color: #343434;
`;

export const ShippingLinkContainer = styled.div`
    margin-top: 30px;

    display: flex;
    justify-content: center;
    align-items: center;
`;
